// extracted by mini-css-extract-plugin
module.exports = {"select":"Select_select__3LmBF","placeholder":"Select_placeholder__3C3aQ"};